import { CHARGE_POINT_REFRESH_TIMEOUT } from '../constants/ChargePointConstants'
import { useChargePointContext } from '../context/ChargePointContext'
import { useChargePointGetQuery } from '../redux/api/web-api'

const useRemoteControlAutoRefresh = (chargePointId?: string, skip = false) => {
    const { autoRefresh } = useChargePointContext()

    const { data: chargePoint } = useChargePointGetQuery(
        {
            chargePointId: chargePointId ?? '',
            expand: 'additionalInfo,scheduleInfo,wifisignal,topChargingLimitation',
        },
        {
            pollingInterval: autoRefresh && !skip ? CHARGE_POINT_REFRESH_TIMEOUT : undefined,
            skip: skip || !chargePointId,
        }
    )

    return chargePoint
}

export default useRemoteControlAutoRefresh
